module.exports = __webpack_public_path__ + "img/ros-mapping.c8ef9d2c.svg";